import { handleActions } from 'redux-actions';
import { initState } from '../../../redux/models';
import * as actionType from './actionType';

export default handleActions(
  {
    //更新信息
    [actionType.RESEVRE_DELIVER_UPDATA]: (state, { data }) => {
      const newState = { ...state, ...data };
      return newState;
    },
    [actionType.RESEVRE_DELIVER_FILE]: state => {
      const newState = { ...state, tableLoading: false };
      return newState;
    },
  },
  initState,
);
